/* VoltBy - "get your files back" now brings back the party pack too.

   The Worker's /recover answer already carries the pack: alongside the
   invitation it returns packs: [{ gid, sid }]. vbig-getback.js only ever built
   a button for the invitation and mentioned the pack as a grey "party pack
   included" note, so a buyer who proved their email and order number got
   their invitation back and no way at all to their matching pieces.

   This listens for that same answer and adds a row with its own button for
   every pack in it, straight to the pack's download page (/suite/d/<sid>).
   That page mints the download token itself for a paid set, and shows the
   pieces filling in if they are still rendering. It also covers an answer
   that has a pack but no invitation, which the panel used to report as
   "we could not find that order".

   Additive: it never edits vbig-getback.js, it only reads the same response
   and appends to the list that file draws. */
(function () {
  if (window.__vbigGetbackPack) return;
  window.__vbigGetbackPack = true;
  if (!window.fetch || !document.querySelector) return;

  var T = {
    en: { title: 'Your matching party pieces', btn: 'Open my pieces', opening: 'Opening…', found: 'Found it.' },
    fr: { title: 'Vos pièces assorties', btn: 'Ouvrir mes pièces', opening: 'Ouverture…', found: 'Trouvé.' },
    es: { title: 'Tus piezas a juego', btn: 'Abrir mis piezas', opening: 'Abriendo…', found: 'Lo encontramos.' },
    ar: { title: 'قطعك المتناسقة', btn: 'افتح قطعي', opening: 'جارٍ الفتح…', found: 'وجدناه.' }
  };
  function lang() {
    try {
      var r = document.querySelector('[data-vbig]');
      var l = r && r.getAttribute('lang');
      return T[l] ? l : 'en';
    } catch (e) { return 'en'; }
  }
  function t() { return T[lang()]; }
  function cfg() {
    try { return JSON.parse(document.querySelector('[data-vbig-config]').textContent || '{}'); }
    catch (e) { return {}; }
  }
  function base() {
    var u = String(cfg().url || cfg().backend_url || '').trim();
    return u.replace(/\/+$/, '') || 'https://voltby-generator.chakk-unes.workers.dev';
  }
  var SID = /^[A-Za-z0-9_-]{8,64}$/;

  function packRow(pk) {
    var li = document.createElement('li');
    li.setAttribute('data-vbgb-pack', pk.sid);
    var tx = document.createElement('div');
    var b = document.createElement('b');
    b.textContent = t().title;
    tx.appendChild(b);
    li.appendChild(tx);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = t().btn;
    btn.addEventListener('click', function () {
      btn.disabled = true;
      btn.textContent = t().opening;
      var q = [];
      if (pk.t) q.push('t=' + encodeURIComponent(pk.t));
      q.push('lang=' + lang());
      location.assign(base() + '/suite/d/' + pk.sid + '?' + q.join('&'));
    });
    li.appendChild(btn);
    return li;
  }

  /* vbig-getback.js paints the list in the same tick it reads the answer, so
     give it a moment and then add to what it drew */
  function augment(ans, tries) {
    var hits = document.getElementById('vbgb-hits');
    var msg = document.getElementById('vbgb-msg');
    if (!hits) return;
    var packs = (ans.packs || []).filter(function (p) { return p && SID.test(String(p.sid || '')); });
    if (!packs.length) return;
    var items = ans.items || [];
    var rows = hits.querySelectorAll('li:not([data-vbgb-pack])');
    if (items.length && rows.length < items.length && tries < 20) {
      setTimeout(function () { augment(ans, tries + 1); }, 60);
      return;
    }
    var seen = {};
    packs.forEach(function (pk) {
      if (seen[pk.sid] || hits.querySelector('[data-vbgb-pack="' + pk.sid + '"]')) return;
      seen[pk.sid] = true;
      var row = packRow(pk);
      /* right under its own invitation when there is one, else at the end */
      var at = -1;
      for (var i = 0; i < items.length; i++) if (items[i] && items[i].gid === pk.gid) { at = i; break; }
      var after = at >= 0 ? rows[at] : null;
      if (after && after.parentNode === hits) hits.insertBefore(row, after.nextSibling);
      else hits.appendChild(row);
    });
    /* a pack with no invitation on the order is still a found order */
    if (!items.length && msg) { msg.textContent = t().found; msg.className = ''; }
  }

  var of = window.fetch;
  window.fetch = function (input, init) {
    var p = of.apply(this, arguments);
    try {
      var u = typeof input === 'string' ? input : ((input && input.url) || '');
      var m = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (m === 'POST' && /\/recover$/.test(u.split('?')[0])) {
        p.then(function (r) {
          if (!r || !r.ok) return;
          r.clone().json().then(function (j) {
            if (j && j.ok === true) setTimeout(function () { augment(j, 0); }, 0);
          }).catch(function () {});
        }, function () {});
      }
    } catch (e) {}
    return p;
  };
})();
